/**
 * Dummy throwing read.
 */
export function read() {
    throw new Error('read is not implemented in the browser');
}
/**
 * Dummy throwing readSync.
 */
export function readSync() {
    throw new Error('readSync is not implemented in the browser');
}
//# sourceMappingURL=read.browser.js.map